<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-group">
	<!--		-->
	<!-- Info	-->
	<!--		-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="main-group-title">Update the facility location.</label>
		</div>
	</div>

	<!--			 -->
	<!-- Info (FYI)  -->
	<!--	 		 -->
	<!-- <div class="main-group-item" style="margin-top:0px">
		<div class="main-group-item-center-padding">
			<label class="main-group-info">Note: </label>
		</div>
	</div> -->

	<!-- 	  -->
	<!-- Code -->
	<!-- 	  -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Code</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<input type="text" pInputText [(ngModel)]="FacilityLocationCD" />
			</div>
		</div>
	</div>

	<!-- 	  -->
	<!-- Name -->
	<!-- 	  -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Name</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<input type="text" pInputText [(ngModel)]="FacilityLocationName" />
			</div>
		</div>
	</div>

	<!--  	   	 	       -->
	<!-- Facility Selector -->
	<!-- 			       -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Facility</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="SelectedSchoolFacilitySelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedSchoolFacility"
					(ngModelChange)="onSchoolFacilityChange($event)"
					[disabled]="isAllowFacilityChange == false"
				>
					<option *ngFor="let r of lstSchoolFacility" [ngValue]="r">
						{{ r.FacilityName }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onEdit()" [disabled]="isBusy == true">Update</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
